import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

let stytchClient: StytchB2BUIClient | null = null;

/**
 * Initialize and get Stytch B2B client
 */
export const getStytchClient = (): StytchB2BUIClient => {
  if (!stytchClient) {
    // Get public token from environment variable
    const publicToken = import.meta.env.VITE_STYTCH_PUBLIC_TOKEN;

    if (!publicToken) {
      console.error('VITE_STYTCH_PUBLIC_TOKEN is not set in environment variables');
      throw new Error('Stytch public token is not configured');
    }

    // Initialize Stytch B2B client with public token
    console.log('Initializing Stytch B2B Client with token:', publicToken);
    stytchClient = new StytchB2BUIClient(publicToken);
    console.log('✅ Stytch B2B client initialized');
  }

  return stytchClient;
};

export default {
  getStytchClient
};

